<template>
  <div v-show="visiable" id="WebPage">
    <guide-button class="btn-lt" :style="{ zIndex: 10000 }" @click.native="close">返回</guide-button>
    <iframe v-if="visiable" width="100%" height="100%" :src="src" frameborder="0"/>
  </div>
</template>

<script>
export default {
  name: 'WebPage',
  data () {
    return {
      visiable: false,
      src: '',
      callback: {},
    }
  },
  methods: {
    show () {
      this.visiable = true
    },
    close () {
      this.visiable = false
      this.callback()
    },
  },
}
</script>

<style lang="scss" scoped>
#WebPage {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 9999;
  width: 19.2rem;
  height: 10.8rem;
  background-color: #fff;
}
</style>
